import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { COMPONENT_META_DATA } from '../../../common/constants/component-meta-data';
import { NewsAnnouncements, NewsAnnouncementsResponse } from '../leap-motor.viewmodel';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { ActivatedRoute, Router } from '@angular/router';
import { ContentModel } from '../../../common/models/content.model';
import { PageJsonResults } from '../../../common/services/page/page-data.viewmodel';
import { LeapMotorService } from '../leap-motor.service';
import { MatCardModule } from "@angular/material/card";
import { ContentFilterPipe } from "../../../common/pipes/content-filter.pipe";
import { IconComponent } from "../../../common/components/general/icon/icon.component";
import { LinkButtonComponent } from "../../../common/components/general/link-button/link-button.component";
import { LPMI_ROUTES } from '../../../common/constants/routes';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CacheService } from '../../../common/services/cache.service';
import { PageService } from '../../../common/services/page/page.service';
// import { CACHE_KEYS } from '../../../common/constants/cache-keys';
// import { LoginSelections } from '../../../login/login.viewmodel';

@Component({
  selector: 'nuc-leap-motor-news',
  imports: [MatCardModule, ContentFilterPipe, LinkButtonComponent, MatPaginatorModule],
  templateUrl: './leap-motor-news.component.html',
  styleUrl: './leap-motor-news.component.scss',
  // encapsulation: ViewEncapsulation.None
})
export class LeapMotorNewsComponent implements OnInit {
  componentType: string = COMPONENT_META_DATA.NEWS_ANNOUNCEMENTS.VALUE;
  LABELS = COMPONENT_META_DATA.NEWS_ANNOUNCEMENTS.LABELS;
  pageContent: ContentModel[] = [];
  newsList: NewsAnnouncements[] = [];
  showAll: boolean = false;

  pagedNewsList: NewsAnnouncements[] = [];
  pageSize = 5;
  currentPage = 0;
  linkPath?: string;

  // poc: Flag to enable/disable AEM Universal Editor integration
  poc: boolean = true;

  // poc: AEM Universal Editor integration paths
  // private readonly AUE_BASE_PATH = '/content/experience-fragments/lpmi';
  private readonly AUE_COMPONENT_SUFFIX = '/jcr:content/root/container/lpmi_container/article';

  // poc: Returns AUE resource URN when poc flag is enabled
 getAueResourceForItem(item: NewsAnnouncements): string | undefined {
  if (this.poc) {
    const linkPath = item?.linkPath ?? '';
    return `urn:aemconnection:${linkPath}${this.AUE_COMPONENT_SUFFIX}`;
  }
  return undefined;
}

  constructor(private route: ActivatedRoute, private leapMotorService: LeapMotorService, private router: Router,
    public sanitizer: DomSanitizer, private cacheService: CacheService, private pageService: PageService
  ) { }

  ngOnInit(): void {
    this.showAll = this.route.snapshot.data['showAll'] || false;
    let routerData: PageJsonResults = this.route.snapshot.data['pageData'];
    this.pageContent = this.leapMotorService.getContent(this.componentType, routerData);
    this.leapMotorService.getNewsListData(this.componentType, routerData, this.showAll)
      .subscribe((data: NewsAnnouncementsResponse) => {
        const fullList = data?.results?.newsPromotionsList || [];
        this.newsList = fullList;

        if (this.showAll) {
          this.updatePagedNews(); // Populate pagedNewsList
        } else {
          this.newsList = fullList.slice(0, 3);
        }
      });

  }

  updatePagedNews() {
    const start = this.currentPage * this.pageSize;
    const end = start + this.pageSize;
    this.pagedNewsList = this.newsList.slice(start, end);
  }

  onPageChange(event: PageEvent) {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.updatePagedNews();
  }

  redirectToArticle(item?: NewsAnnouncements) {
    if (item?.id) {
      this.router.navigate([`/${LPMI_ROUTES.ARTICLE.PATH}`], {
        queryParams: {
          id: item.id,
          linkPath: item.linkPath,
        },
      });
    }
  }

  onClick() {
      this.router.navigate([`/${LPMI_ROUTES.NEWS_ANNOUNCEMENTS.PATH}`]);
  }


  getSanitizedText(text: string) {
    const textArea = document.createElement('textarea');
    textArea.innerHTML = text;
    // Decode and sanitize the HTML
    let htmlSnippet: SafeHtml | undefined = this.sanitizer.bypassSecurityTrustHtml(textArea.value);
    return htmlSnippet;
  }

  onKeyDown(event: KeyboardEvent) {
    // Handle keydown event on description element
    console.log('Key pressed:', event.key);
  }
}

